import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum ConnectionStatus {
  Uninitialized = 'Uninitialized',
  IsConnecting = 'IsConnecting',
  IsConnected = 'IsConnected',
  ConnectionFailed = 'ConnectionFailed'
}

export interface SignalRState {
  connectionStatus: ConnectionStatus;
  requestStart?: boolean;
  error?: string;
}

const initialState: SignalRState = {
  connectionStatus: ConnectionStatus.Uninitialized,
  error: undefined,
  requestStart: false
};

export const signalRSlice = createSlice({
  name: 'signalR',
  initialState,
  reducers: {
    setConnectionStatus: (state, action: PayloadAction<ConnectionStatus>) => {
      state.connectionStatus = action.payload;
      if (action.payload !== ConnectionStatus.ConnectionFailed) {
        state.error = undefined;
      }
    },
    setConnecting: state => {
      state.connectionStatus = ConnectionStatus.IsConnecting;
      state.error = undefined;
    },
    setConnected: state => {
      state.connectionStatus = ConnectionStatus.IsConnected;
      state.error = undefined;
    },
    setConnectionFailed: (state, action: PayloadAction<string | undefined>) => {
      state.connectionStatus = ConnectionStatus.ConnectionFailed;
      state.error = action.payload;
    },
    resetConnection: state => {
      state.connectionStatus = ConnectionStatus.Uninitialized;
      state.error = undefined;
    },
    requestStart: state => {
      state.requestStart = true;
    }
  }
});

export const {
  setConnectionStatus,
  setConnecting,
  setConnected,
  setConnectionFailed,
  resetConnection,
  requestStart
} = signalRSlice.actions;

export default signalRSlice.reducer;
